/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CreateNotificationScheduleRequest } from "./CreateNotificationScheduleRequest";
import {
    CreateNotificationScheduleRequestFromJSON,
    CreateNotificationScheduleRequestFromJSONTyped,
    CreateNotificationScheduleRequestToJSON,
} from "./CreateNotificationScheduleRequest";

/**
 *
 * @export
 * @interface UpdateNotificationPreferenceRequest
 */
export interface UpdateNotificationPreferenceRequest {
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateNotificationPreferenceRequest
     */
    notificationMethods?: Array<UpdateNotificationPreferenceRequestNotificationMethodsEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateNotificationPreferenceRequest
     */
    notificationTypes?: Array<UpdateNotificationPreferenceRequestNotificationTypesEnum>;
    /**
     *
     * @type {string}
     * @memberof UpdateNotificationPreferenceRequest
     */
    notificationFrequency?: UpdateNotificationPreferenceRequestNotificationFrequencyEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateNotificationPreferenceRequest
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateNotificationPreferenceRequest
     */
    deviceIdentities?: Array<string>;
    /**
     *
     * @type {CreateNotificationScheduleRequest}
     * @memberof UpdateNotificationPreferenceRequest
     */
    schedule?: CreateNotificationScheduleRequest;
    /**
     *
     * @type {boolean}
     * @memberof UpdateNotificationPreferenceRequest
     */
    removeSchedule?: boolean;
}

/**
 * @export
 */
export const UpdateNotificationPreferenceRequestNotificationMethodsEnum = {
    Unknown: "Unknown",
    Email: "Email",
    Sms: "SMS",
    PushNotification: "PushNotification",
} as const;
export type UpdateNotificationPreferenceRequestNotificationMethodsEnum =
    (typeof UpdateNotificationPreferenceRequestNotificationMethodsEnum)[keyof typeof UpdateNotificationPreferenceRequestNotificationMethodsEnum];

/**
 * @export
 */
export const UpdateNotificationPreferenceRequestNotificationTypesEnum = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
} as const;
export type UpdateNotificationPreferenceRequestNotificationTypesEnum =
    (typeof UpdateNotificationPreferenceRequestNotificationTypesEnum)[keyof typeof UpdateNotificationPreferenceRequestNotificationTypesEnum];

/**
 * @export
 */
export const UpdateNotificationPreferenceRequestNotificationFrequencyEnum = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;
export type UpdateNotificationPreferenceRequestNotificationFrequencyEnum =
    (typeof UpdateNotificationPreferenceRequestNotificationFrequencyEnum)[keyof typeof UpdateNotificationPreferenceRequestNotificationFrequencyEnum];

/**
 * Check if a given object implements the UpdateNotificationPreferenceRequest interface.
 */
export function instanceOfUpdateNotificationPreferenceRequest(
    value: object,
): value is UpdateNotificationPreferenceRequest {
    return true;
}

export function UpdateNotificationPreferenceRequestFromJSON(
    json: any,
): UpdateNotificationPreferenceRequest {
    return UpdateNotificationPreferenceRequestFromJSONTyped(json, false);
}

export function UpdateNotificationPreferenceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateNotificationPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        notificationMethods:
            json["notificationMethods"] == null
                ? undefined
                : json["notificationMethods"],
        notificationTypes:
            json["notificationTypes"] == null
                ? undefined
                : json["notificationTypes"],
        notificationFrequency:
            json["notificationFrequency"] == null
                ? undefined
                : json["notificationFrequency"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        deviceIdentities:
            json["deviceIdentities"] == null
                ? undefined
                : json["deviceIdentities"],
        schedule:
            json["schedule"] == null
                ? undefined
                : CreateNotificationScheduleRequestFromJSON(json["schedule"]),
        removeSchedule:
            json["removeSchedule"] == null ? undefined : json["removeSchedule"],
    };
}

export function UpdateNotificationPreferenceRequestToJSON(
    value?: UpdateNotificationPreferenceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        notificationMethods: value["notificationMethods"],
        notificationTypes: value["notificationTypes"],
        notificationFrequency: value["notificationFrequency"],
        deviceGroupTags: value["deviceGroupTags"],
        deviceIdentities: value["deviceIdentities"],
        schedule: CreateNotificationScheduleRequestToJSON(value["schedule"]),
        removeSchedule: value["removeSchedule"],
    };
}
